import { useEffect } from 'react';
import { initGA4 } from '../hooks/useTrackEvent';

/** Loads GTM once at app root when REACT_APP_GTM_ID is set. */
export default function GA4Provider({ children }) {
  useEffect(() => {
    initGA4();
  }, []);

  return children;
}
